'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assignFileUniqueIds;
/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// given an array of files, assigns id to all of them based on
// uuid function provided
function assignFileUniqueIds(files, uuidFunction) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var key = config.key || 'id';

  files.forEach(function (file, index) {
    file[key] = uuidFunction(file, index, files, config);
  });

  return files;
}